import superagent from 'superagent'
import { circlesSet } from './circle-actions'
import { linesSet } from './line-actions'
import { polygonsSet } from './polygon-actions'
import { tracksSet } from './track-actions'
import { markersSet } from './marker-actions'
import { photosSet } from './photo-actions'
import { boundariesSet } from './boundary-actions'

export const setChangesLastCalled = () => {
  let now = new Date()
  return {
    type: 'CHANGES_LAST_CALLED_SET',
    payload: now.toISOString()
  }
}

const prune = (map) => {
  const arr = []
  map.forEach(obj => {
    if (obj.deleted) {
      return
    }
    arr.push(obj)
  })
  return arr
}

const changesRequest = (page, token, measures = {}, dispatch, date) => {
  const typeMap = {
    1: 'tracks',
    3: 'polygons',
    4: 'lines',
    5: 'circles'
  },
    getDeleted = date === '2018-01-01T00:00:00.000Z' ? false : true

  return new Promise((resolve, reject) => {
    superagent
      .get(`${__API_URI_2__}/changes/get?activityId=1&asOfDate=${date}&page=${page}&pageSize=100&includeDeletedContent=${getDeleted}`)
      .set('Content-Type', 'application/json')
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (res.body.measurements.length === 0 && res.body.markers.length === 0 && res.body.photos.length === 0) {
          measures.markers = prune(measures.markers)
          measures.photos = prune(measures.photos)
          measures.lines = prune(measures.lines)
          measures.polygons = prune(measures.polygons)
          measures.circles = prune(measures.circles)
          measures.tracks = prune(measures.tracks)
          measures.mapBoundaries = prune(measures.mapBoundaries)
          resolve(measures)
        } else {
          res.body.markers.forEach(marker => measures.markers.set(marker.id, marker))
          res.body.photos.forEach(photo => measures.photos.set(photo.id, photo))
          res.body.mapBoundaries.forEach(boundary => {
            boundary.measureType = 'boundary'
            measures.mapBoundaries.set(boundary.id, boundary)
          })
          res.body.measurements.forEach(measure => {
            measures[typeMap[measure.measurementTypeId]].set(measure.id, measure)
          })
          resolve(changesRequest(page + 1, token, measures, dispatch, date))
        }
      })
  })
}

const fetchPhoto = (photoId, token) => {
  $.ajax({
    method: 'GET',
    url: `${__API_URI__}/photo/get/${photoId}`,
    headers: {
      Authorization: `Bearer ${token}`,
      Platform: 'Web',
      Version: `${__version__}`
    }
  }).done(res => {
    s.photo = res
  })
}

export const fetchChanges = () => (dispatch, getState) => {
  const storeChanges = getState().changesLastCalled,
    changesDate = storeChanges ? storeChanges : '2018-01-01T00:00:00.000Z',
    token = getState().auth.token,
    lines = new Map(),
    circles = new Map(),
    polygons = new Map(),
    tracks = new Map(),
    markers = new Map(),
    photos = new Map(),
    mapBoundaries = new Map(),
    measures = {
      tracks,
      polygons,
      lines,
      circles,
      markers,
      photos,
      mapBoundaries
    }
  getState().lines.forEach(line => lines.set(line.id, line))
  getState().circles.forEach(circle => circles.set(circle.id, circle))
  getState().polygons.forEach(polygon => polygons.set(polygon.id, polygon))
  getState().tracks.forEach(track => tracks.set(track.id, track))
  getState().markers.forEach(marker => markers.set(marker.id, marker))
  getState().photos.forEach(photo => photos.set(photo.id, photo))
  getState().boundaries.forEach(boundary => mapBoundaries.set(boundary.id, boundary))

  dispatch(setChangesLastCalled())
  return changesRequest(0, token, measures, dispatch, changesDate)
    .then(res => {
      dispatch(linesSet(res.lines))
      dispatch(circlesSet(res.circles))
      dispatch(polygonsSet(res.polygons))
      dispatch(tracksSet(res.tracks))
      dispatch(markersSet(res.markers))
      dispatch(photosSet(res.photos))
      dispatch(boundariesSet(res.mapBoundaries))
    })
}
